import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Survey, SurveySummary } from "src/app/backend/models/survey";
import { omitUndefinedAndNullProperties } from "src/app/support/object";
import { PageRequest } from "src/app/support/page-request";
import { PaginatedResult } from "src/app/support/paginated-result";
import { environment } from "src/environments/environment";

@Injectable()
export class SurveyBackend {
  private readonly http = inject(HttpClient);

  load(id: string): Observable<Survey> {
    return this.http.get<Survey>(
      `${environment.snoots.api.healthcare}/surveys/${id}`
    );
  }

  loadPublic(id: string): Observable<Survey> {
    return this.http.get<Survey>(
      `${environment.snoots.api.healthcare}/public/surveys/${id}`
    );
  }

  loadSummary(): Observable<SurveySummary> {
    return this.http.get<SurveySummary>(
      `${environment.snoots.api.healthcare}/surveys/summary`
    );
  }

  complete({
    id,
    satisfaction,
    note
  }: {
    id: string;
    satisfaction: number;
    note?: string;
  }): Observable<void> {
    return this.http.put<void>(
      `${environment.snoots.api.healthcare}/public/surveys/${id}/complete`,
      omitUndefinedAndNullProperties({
        satisfaction,
        note
      })
    );
  }

  list(
    pageRequest: PageRequest,
    { status }: { status: "completed" | undefined }
  ) {
    return this.http.get<PaginatedResult<Survey>>(
      `${environment.snoots.api.healthcare}/surveys`,
      {
        params: omitUndefinedAndNullProperties({
          p: pageRequest.page,
          s: pageRequest.pageSize,
          status
        })
      }
    );
  }

  listLightByCustomer({
    customerId,
    status
  }: {
    customerId: string;
    status: "completed" | undefined;
    pageRequest: PageRequest;
  }): Observable<PaginatedResult<Survey>> {
    return this.http.get<PaginatedResult<Survey>>(
      `${environment.snoots.api.healthcare}/customers/${customerId}/surveys`,
      {
        params: omitUndefinedAndNullProperties({ status, light: true })
      }
    );
  }
}
